<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">商品列表</h1>
                    <p class="text-white pb-3 px-3">เลือกจำนวนเครดิต หรือ ระบุจำนวนเครดิต เพื่อทำการเติมเข้ากระเป๋าของคุณ
                    </p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-4">
                                    <b-input-group class="mb-3">
                                        <b-form-input v-model="keyword"></b-form-input>

                                        <b-input-group-append>
                                            <b-button variant="primary" @click="searchList">查询</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                                <div class="col-lg-4">
                                    <b-button variant="primary" @click="Taxation">税务注册信息</b-button>
                                    <b-button variant="primary" @click="addGoods">增加商品</b-button>
                                </div>
                            </div>
                            <div>
                                <b-table
                                    ref="reportDelivery"
                                    show-empty
                                    responsive
                                    :items="tableList"
                                    :fields="fields"
                                    :per-page="pageSize"
                                    :busy="busy"
                                    selectable
                                    select-mode="multi"
                                    class="scroll-bar-pop text-center"
                                    empty-text="暂无数据"
                                    empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                >
                                    <!--                                <template slot="goodsNo" slot-scope="{item}">-->
                                    <!--                                    {{(pageIndex - 1) * pageSize + item.index + 1}}-->
                                    <!--                                </template>-->
                                    <template slot="logo" slot-scope="{item}">
                                        <img :src="item.picUrl" v-if="item.picUrl" style="width: 128px;height:72px;" alt="">
                                        <img v-else src="@/assets/images/newImg/default-prod.png" style="width: 128px;height:72px;" alt="">
                                    </template>
                                    <template slot="action" slot-scope="{item}">
                                        <b-button variant="primary" size="sm" @click="handleEdit(item)">编辑</b-button>
                                        <b-button variant="success" size="sm" @click="setTop(item)">置顶</b-button>
                                        <b-button variant="danger" size="sm" @click="handleDelete(item)">删除</b-button>
                                    </template>
                                </b-table>
                                <div class="mt-3">
                                    <b-pagination
                                        :total-rows="total"
                                        :current-page="pageIndex"
                                        :per-page="pageSize"
                                        :value="pageIndex"
                                        @input="changePage"
                                        align="right">
                                    </b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal
            centered
            hide-footer
            v-model="goodsShow"
            size="md"
            :title="title"
        >
            <b-form @submit="onSubmit">
                <b-form-group
                    id="input-group-1"
                    label="商品名称"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        v-model="commodityData.spuName"
                        placeholder="请输入商品名称"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-1"
                    label="商品明细"
                    label-for="input-1"
                >
                    <b-form-textarea
                        id="input-1"
                        v-model="commodityData.spuDesc"
                        placeholder="请输入商品明细"
                    ></b-form-textarea>
                </b-form-group>
                <b-form-group
                    id="input-group-1"
                    label="成本价"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        type="number"
                        v-model="commodityData.costPrice"
                        placeholder="请输入成本价"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-1"
                    label="库存"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        type="number"
                        v-model="commodityData.stock"
                        placeholder="请输入库存"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-1"
                    label="销售价（Vat7%）"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        @update="changeRetailPrice"
                        type="number"
                        required
                        v-model="commodityData.retailPrice"
                        placeholder="请输入销售价（Vat7%）"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-1"
                    label="销售价"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        disabled
                        v-model="commodityData.preTaxiPrice"
                        placeholder="销售价"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-1"
                    label="Vat7%"
                    label-for="input-1"
                >
                    <b-form-input
                        id="input-1"
                        disabled
                        v-model="commodityData.vat7"
                        placeholder="Vat7%"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="input-group-1"
                    label="商品照片"
                    label-for="input-1"
                >
                    <upload :imageUrl="commodityData.picUrl" @updateImage="updateImage" :borderRadius="`10px`"></upload>
                </b-form-group>
                <div class="d-flex justify-content-center mt-4">
                    <b-button
                        class="px-5"
                        variant="secondary"
                        @click="closeModal()"
                    >
                        ยกเลิก
                    </b-button>
                    <b-button
                        class="px-5"
                        variant="primary"
                        type="submit"
                    >
                        ยืนยัน
                    </b-button>
                </div>
            </b-form>

        </b-modal>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import {addCommodity, CommodityPage, deleteCommodity, topCommodity} from "@/api/productManagement";
import upload from "@/views/newPages/upload.vue"
export default {
    name: "",
    components: {
        upload
    },
    data() {
        return {
            keyword: '',
            title: '',
            commodityData: {},
            goodsShow: false,
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            busy: false,
            tableList: [],
            fields: [
                {
                    key: 'logo',
                    label: '商品图片',
                    sortable: true
                },
                {
                    key: 'spuName',
                    label: '商品名称',
                    sortable: true
                },
                {
                    key: 'spuDesc',
                    label: '商品明细',
                    sortable: true
                },
                {
                    key: 'stock',
                    label: '库存',
                    sortable: true
                },
                {
                    key: 'status',
                    label: '成本价',
                    sortable: true
                },
                {
                    key: 'status',
                    label: '销售价',
                    sortable: true
                },
                {
                    key: 'vat7',
                    label: 'Vat7%',
                    sortable: true
                },
                {
                    key: 'retailPrice',
                    label: '销售价（Vat7%）',
                    sortable: true
                },
                {
                    key: 'action',
                    label: '操作',
                    sortable: true
                }
            ],
        }
    },
    created() {

    },
    mounted() {
        this.CommodityPage()
    },
    methods: {
        Taxation() {
            this.$router.push({
                path: '/StoreManagement',
                query: {
                    settingTab: 'accountInfo',
                    certification: 'taxCertification'
                }
            })
        },
        addGoods() {
            this.title = '新增商品'
            this.goodsShow = true
            this.commodityData = {}
        },
        changeRetailPrice(){
            // this.form.preTaxiPrice=  this.form.retailPrice*100/107
            this.commodityData.preTaxiPrice=  (this.commodityData.retailPrice*100/107).toFixed(2)
            this.commodityData.vat7= (this.commodityData.preTaxiPrice*7/100).toFixed(2)
        },
        updateImage(url) {
            console.log(url)
            this.commodityData.picUrl = url
        },
        closeModal() {
            this.goodsShow = false
            this.commodityData = {}
        },
        onSubmit(evt) {
            evt.preventDefault()
            console.log(this.commodityData)
            addCommodity(this.commodityData).then(res => {
                console.log(res)
                this.$bvModal.msgBoxOk('操作成功', {
                    title: "SUCCESS",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: "ตกลง",
                    contentClass: "modal-success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                });
                this.pageIndex = 1
                this.CommodityPage()
                this.closeModal()
            })
        },
        handleEdit(row){
            console.log(row);
            this.commodityData = row
            this.title = '编辑商品'
            this.goodsShow = true
        },
        handleDelete (row) {
            this.$bvModal.msgBoxConfirm('คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้?', {
                title: 'ยืนยันการลบ',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'ตกลง',
                cancelTitle: 'ยกเลิก',
                footerClass: 'p-2',
                centered: true
            })
                .then(value => {
                    if (value) {
                        console.log(row)
                        deleteCommodity({
                            id: row.id
                        }).then(res => {
                            this.$bvModal.msgBoxOk('操作成功', {
                                title: "SUCCESS",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                okTitle: "ตกลง",
                                contentClass: "modal-success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true
                            });
                            this.pageIndex = 1
                            this.CommodityPage()
                        })
                    }
                })
        },
        setTop (row) {
            topCommodity({
                id: row.id
            }).then(res => {
                this.$bvModal.msgBoxOk('操作成功', {
                    title: "SUCCESS",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    okTitle: "ตกลง",
                    contentClass: "modal-success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true
                });
                this.pageIndex = 1
                this.CommodityPage()
            })
        },
        changePage(page) {
            if (page === this.pageIndex) return
            this.pageIndex = page
            this.CommodityPage()
        },
        searchList() {
            this.pageIndex = 1
            this.CommodityPage()
        },
        CommodityPage() {
            CommodityPage({
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                keyword: this.keyword
            }).then(res => {
                console.log(res)
                this.tableList = res.data.records
                this.total = res.data.total
            })
        }
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>